export const removeSpaces = str => {

    const regex = /\-/g;
    const rgx = new RegExp(regex);

    return str.replace(rgx, ' ');
};


// WEBPACK FOOTER //
// ./src/services/formatters/removeSpaces.js